<template>
  <div class="rc-report" ref="rcReportDesign">
    <label class="rc-report-label">{{initComponent.name}}</label>
    <div :class="['rc-report-content', component.properties.report.sourceTableId && 'rc-report-height']">
      <report-runtime v-if="component.properties.report.sourceTableId" :id="component.properties.report.sourceTableId" :referenceObjParam="referenceObjParam" :key="component.properties.report.sourceTableId"></report-runtime>
      <el-table v-else
                :data="tempData"
                border
                :header-row-style="{height:'28px', cursor:'pointer'}"
                :row-style="{height:'28px', cursor:'pointer',backgroundColor:'#fff'}"
                height="100%">
        <el-table-column v-for="(item, index) in columns" :key="index"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
import ReportRuntime from '@/components/report/runtime/report-runtime.vue'

export default {
  name: 'rc-report',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  components: {
    ReportRuntime
  },
  computed: {
    columns () {
      let childrenComponent = []
      for (let i = 0; i < 4; i++) {
        childrenComponent.push({})
      }
      return childrenComponent
    }
  },
  watch: {
    'component.properties.report.filters': {
      async handler (val) {
        if (val) {
          let filters = this.$_.cloneDeep(val)
          await this.handlerFilter(filters)
          this.referenceObjParam.params.filters = filters
          // 重新渲染报表
          let tempSourceId = this.component.properties.report.sourceTableId
          this.component.properties.report.sourceTableId = null
          setTimeout(() => {
            this.component.properties.report.sourceTableId = tempSourceId
          }, 0)
        }
      },
      deep: true
    },
    'component.properties.report.defaultRows' (val) {
      this.referenceObjParam.params.index = 1
      this.referenceObjParam.params.size = val
      // 重新渲染报表
      let tempSourceId = this.component.properties.report.sourceTableId
      this.component.properties.report.sourceTableId = null
      setTimeout(() => {
        this.component.properties.report.sourceTableId = tempSourceId
      }, 0)
    }
  },
  data () {
    return {
      referenceObjParam: {
        type: 'rc-report',
        params: {
          index: 1,
          size: 4,
          filters: {}
        }
      },
      component: this.initComponent,
      tempData: [{}, {}, {}]
    }
  },
  methods: {
    // 处理筛选项表达式
    handlerFilter (val) {
      let promises = []
      Object.keys(val).forEach(m => {
        promises.push(new Promise(resolve => {
          if (val[m].match(/\${(.+?)\}/g)) {
            val[m] = ''
          } else if (val[m]) {
            this.$axios.post(`/form-api/${this.$route.name === 'formRuntimeOutsideChain' ? 'publicPublish/' : ''}runtime/calc`, {'formula': val[m]})
              .then(res => {
                val[m] = res.data
                resolve()
              })
          }
          resolve()
        }))
      })
      return Promise.all(promises)
    }
  }
}
</script>
<style lang="scss">
  .rc-report{
    .rc-report-label{
      display: block;
    }
    .rc-report-content.rc-report-height{
      height: 270px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/report/rc-report.vue